/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Vakanties_Naam_VanInputs */

const nl_planning_vakanties_naam_van = /** @type {(inputs: Planning_Vakanties_Naam_VanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naam van ${i?.naam}`)
};

/**

* @param {Planning_Vakanties_Naam_VanInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_naam_van = /** @type {((inputs: Planning_Vakanties_Naam_VanInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Naam_VanInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_naam_van(inputs)
});
export { planning_vakanties_naam_van as "planning.vakanties.naam_van" }